<template>
<v-container class="pa-0">
  <v-row>
    <v-col class="pa-0">
<v-layout justify-center>
<v-data-table
:headers="headers"
:items="usuarios"
sort-by="calories"
class="elevation-1"
:footer-props="{
  'items-per-page-text':'Filas por página'
}"
>
<template v-slot:top>
  <v-toolbar flat color="white">
    <v-toolbar-title>Listado de usuarios</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
            color="primary"
            dark
            class="mb-2"
            v-bind="attrs"
            v-on="on"
            ><v-icon dark left>mdi-plus</v-icon>Nuevo usuario</v-btn>
        </template>
         <v-card>
        <v-toolbar>

        <v-toolbar-title>{{formTitle}}</v-toolbar-title>

      <template v-slot:extension>
        <v-tabs v-model="tabs">
          <v-tab
            v-for="item in items"
            :key="item.name"
            :disabled="item.disabled"
          >
            {{ item.name }}
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <v-card>
            <v-card-text>
            <v-form
              ref="form1"
              v-model="valid0"
            >
            <v-container class="grey lighten-5">
             <v-row no-gutters>
                <v-col>
                    <v-text-field
                    v-model="editedItem.username"
                    label="Nombre de usuario"
                    required
                    :rules="[v => !!v || 'El campo es requerido']"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-text-field
                        v-model="editedItem.first_name"
                        label="Nombre"
                        required
                        :rules="[v => !!v || 'El campo es requerido']"
                    ></v-text-field>
                </v-col>

                <v-col sm="1">
                </v-col>
                
                <v-col>
                    <v-text-field
                        v-model="editedItem.last_name"
                        label="Apellido"
                        required
                        :rules="[v => !!v || 'El campo es requerido']"
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-text-field
                        v-model="editedItem.email"
                        label="Email"
                        :rules="emailRules"
                        required
                    ></v-text-field>
                    <v-checkbox
                        v-model="editedItem.is_active"
                        label="Autorizado"
                    ></v-checkbox>
                </v-col>
            </v-row>
        </v-container>
          </v-form>
            </v-card-text>
             <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cerrar</v-btn>
          <v-btn color="blue darken-1" text @click="save">{{formAction}}</v-btn>
        </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
              <v-container class="grey lighten-5">
            <v-select
            v-model="chips"
            :items="roles"
            chips
            label="Roles"
            item-value="id"
            item-text="name"
            multiple
            outlined
          ></v-select>
          </v-container>
          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cerrar</v-btn>
          <v-btn color="blue darken-1" text @click="save">{{formAction}}</v-btn>
        </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>

          <v-card-text>

              <v-container class="grey lighten-5">
              <v-form
                ref="form3"
                v-model="valid"
              >

                <v-text-field
                    v-model="editedItem.password"
                    label="Nueva contraseña"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    :rules="[v => !!v || 'Este campo es requerido']"
                    counter
                ></v-text-field>

                <v-text-field
                    v-model="password"
                    label="Repetir contraseña"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show2 ? 'text' : 'password'"
                    @click:append="show2 = !show2"
                    :rules="[passwordConfirmationRule]"
                    counter
                ></v-text-field>
              </v-form>
              </v-container>
              

          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cerrar</v-btn>
          <v-btn color="blue darken-1" text @click="save">{{formAction}}</v-btn>
        </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
        </v-dialog>
  </v-toolbar>
</template>
<template v-slot:item.groups="{ item }">
  {{getRol(item.groups)}}
</template>
<template v-slot:item.actions="{ item }">
    <v-icon small @click="editItem(item)">mdi-pencil</v-icon>
    <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
</template>
<template v-slot:no-data>
  No hay datos
</template>
</v-data-table>
</v-layout>
</v-col>
</v-row>
<v-row>

</v-row>



</v-container>
</template>

<script>

  import Vue from "vue";
  import Vuex from "vuex";
  import axios from "axios";
  import VueAxios from "vue-axios";

  Vue.use(Vuex);
  Vue.use(VueAxios, axios);
  Vue.axios.defaults.baseURL = process.env.VUE_APP_HOST;

  export default {

    data: () => ({
      valid: false,
      valid0: false,
      dialog: false,
      show1: false,
      show2: false,
      selected: [],
      search: '',
      headers: [
        { text: 'ID', align: 'start', sortable: true, value: 'id' },
        { text: 'Usuario', value: 'username' },
        { text: 'Nombre', value: 'first_name' },
        { text: 'Apellido', value: 'last_name' },
        { text: 'Email', value: 'email' },
        { text: 'Rol', value: 'groups' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      password: '',
      tabs: null,
      items: [
        {name: 'Datos', disabled: false},
        {name: 'Roles', disabled: true},
        {name: 'Contraseña', disabled: true},
      ],
      chips: [],
      creating: false,

      emailRules: [
        v => !!v || 'El campo es requerido',
        v => /.+@.+\..+/.test(v) || 'El email no es válido',
      ],

    }),

    computed: {
        formTitle () {
            return this.creating ? 'Nuevo usuario' : 'Editar usuario';
        },
        pruebas() {
            return this.$store.state.pruebas;
        },
        user() {
            return this.$store.state.user;
        },
        usuarios() {
            return this.$store.state.usuarios;
        },
        roles() {
            return this.$store.state.roles;
        },
        formAction() {
            return (!this.creating || this.tabs === 2) ? 'Guardar' : 'Continuar';
        },
        created() {
          return this.$store.state.created;
        },
        passwordConfirmationRule() {
          return () => (this.editedItem.password === this.password) || 'Las contraseñas no coinciden'
        },

    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize(),
      this.$store.dispatch('loadUsuarios')
    },

    methods: {
      initialize () {
      },

      editItem (item) {
        this.modTabs(false);
        this.creating = false;
        this.editedIndex = this.usuarios.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.chips = this.editedItem.groups;
        this.dialog = true;
      },

      deleteItem (item) {
        console.log(item);
        confirm('Are you sure you want to delete this item?') && this.$store.dispatch('deleteUsuario', item.id);
      },

        close () {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
            this.chips = [];
            this.password = null;
            this.tabs = null;
            this.modTabs(true);
            this.creating = true;
            this.valid = true;

            if (this.$refs.form3) this.$refs.form3.resetValidation();
            if (this.$refs.form1) this.$refs.form1.resetValidation();
            this.valid = false;
            this.valid0 = false;
        },

        save () {

            this.editedItem['groups'] = this.chips;
            if (this.tabs === 0) {
              this.$refs.form1.validate();
              if (this.valid0) {
                if (this.editedIndex === -1) {
                  Vue.axios.post('usuarios/',  this.editedItem).then(result => {
                    console.log(result);
                    this.$store.dispatch('loadUsuarios');
                    this.editedItem = result.data;
                    this.editedIndex = 1;
                    this.modTabs(false);
                    this.creating = true;
                    this.tabs = this.tabs + 1;
                  }).catch(error => {
                    throw new Error(`API ${error}`);
                  });
                }
                else {
                  this.$store.dispatch('editUsuario', this.editedItem);
                  if (this.creating) {
                      this.tabs = this.tabs + 1;
                  }
                }
              }
            }
            else if (this.tabs === 1) {
                this.$store.dispatch('editUsuario', this.editedItem);
                if (this.creating) {
                    this.tabs = this.tabs + 1;
                }
            }
            else {
              this.$refs.form3.validate();
              if (this.valid) {
                 Vue.axios.put('change_password/' + this.editedItem.id + '/', {password: this.editedItem['password']}).then(result => {
                  console.log(result);
                }).catch(error => {
                  throw new Error(`API ${error}`);
                });
              }
            }

        },

        modTabs(boo) {
          this.items[1].disabled = boo;
          this.items[2].disabled = boo;
        },

        getRol(groups) {
            if (groups.length > 0) {
                return this.roles.find(obj => obj.id === groups[0]).name;
            }
            return "";
        },
    },
  }
</script>

<style scoped>
  .transparent-body {
    background: transparent
  }
</style>
